import { useReducer, useMemo } from 'react';
import { useSubjects, levels } from '@utils/constants';
import { SelectPanel } from '../../../../molecules/select-panel/_select-panel.js';
import { createCourseSlice } from './_create-drawer.state.js';
import { jsx } from 'react/jsx-runtime';

/**
 * Basic wrapper around the SelectPanel specialised for the CreateCourseDrawer
 * which handles temporary state required to cancel etc.
 */
function CreateCourseSelectPanel(props) {
  const subjects = useSubjects();
  const options = props.target === "levels" ? levels : subjects;
  const [courseDraft, dispatch] = useReducer(createCourseSlice.reducer, props.course);
  const callbacks = useMemo(() => ({
    toggleValue: value => {
      switch (props.target) {
        case "levels":
          dispatch(createCourseSlice.actions.toggleLevel(value));
          break;
        case "subjects":
          dispatch(createCourseSlice.actions.toggleSubject(value));
          break;
      }
    },
    onSave: () => props.onSave(courseDraft[props.target])
  }), [props, courseDraft]);
  const label = props.target === "levels" ? "Vælg niveau" : "Vælg fag";
  const inputPlaceholder = props.target === "levels" ? "Søg efter niveau" : "Søg efter fag";
  return /*#__PURE__*/jsx(SelectPanel, {
    multiSelect: true,
    label: label,
    inputPlaceholder: inputPlaceholder,
    selectedValues: courseDraft[props.target],
    options: options,
    onCancel: props.onCancel,
    onSave: callbacks.onSave,
    toggleValue: callbacks.toggleValue
  });
}

export { CreateCourseSelectPanel };
//# sourceMappingURL=select-panel.js.map
